import { FC } from 'react';
import { Chip } from '@mui/material';
import { PostStatus } from '@libs/types';

interface PostStatusChipProps {
  status?: PostStatus | string;
}

export const PostStatusChip: FC<PostStatusChipProps> = ({ status }) => {
  if (!status) return null;

  const formattedStatus = status?.charAt(0).toUpperCase() + status?.slice(1);

  let backgroundColor;
  let color;

  switch (status) {
    case 'active':
      backgroundColor = 'success.light';
      color = 'success.contrastText';
      break;
    case 'expired':
      backgroundColor = 'warning.light';
      color = 'warning.contrastText';
      break;
    case 'closed':
      backgroundColor = 'secondary.main';
      color = 'secondary.contrastText';
      break;
    default:
      backgroundColor = 'secondary.light';
      color = 'secondary.dark';
  }

  return <Chip label={formattedStatus} sx={{ backgroundColor, color }} />;
};
